import { createSlice } from '@reduxjs/toolkit';

// Helpers
import { generateId } from '@/helpers';

const initialState = { signs: [], signsSelected: null, loadingSigns: false };

const signsSlice = createSlice({
  name: 'signs',
  initialState,
  reducers: {
    addSign: (state, action) => {
      state.signs = [...state.signs, { ...action.payload, id: generateId() }];
    },
    selectSign: (state, action) => {
      state.signsSelected = action.payload;
    },
    updatePositionSign: (state, action) => {
      state.signsSelected = {
        ...state.signsSelected,
        [action.payload.page]: {
          ...state.signsSelected[action.payload.page],
          x: action.payload.value.x,
          y: action.payload.value.y
        }
      };
    },
    toggleLoadingSigns: (state, action) => {
      state.loadingSigns = action.payload;
    },
    setSigns: (state, action) => {
      state.signs = action.payload;
    },
    deleteSignToPull: (state, action) => {
      state.signs = state.signs.filter((sign) => sign.id !== action.payload);
    },
    resetSelectedSign: (state) => {
      state.signsSelected = {}; // Restablece signsSelected a un estado vacío o inicial
    }
  }
});

export const {
  addSign,
  selectSign,
  updatePositionSign,
  toggleLoadingSigns,
  setSigns,
  deleteSignToPull,
  resetSelectedSign
} = signsSlice.actions;
export default signsSlice.reducer;
